import React, { useState } from 'react';
import { Container, Grid, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControl, FormLabel, FormControlLabel, Checkbox, Button, Box, Typography } from '@mui/material';

import { submitDPSubjectSelectionForm } from '../api'; // Import the API function
import {  useLocation , useNavigate} from 'react-router-dom';
import { notifySuccess, notifyError } from '../Notification';
import ThankYouModal from '../layout/ThankyouModal';

const DPSubject = () => {
    const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
    const location = useLocation();
    const navigate = useNavigate();
  const child = location.state?.child;
    const [formData, setFormData] = useState({
        program: {
            diploma: false,
            course: false,
            retake: false,
        },
        subjects: {
            'English A (Lang & Lit)': false,
            'English B': false,
            'Urdu A (Lit)': false,
            'French Ab Initio': false,
            'Spanish Ab Initio': false,
            'Arabic Ab Initio': false,
            'Business Management': false,
            'Global Politics': false,
            'Economics': false,
            'Biology': false,
            'Chemistry': false,
            'Physics': false,
            'Mathematics': false,
            'Mathematical Studies': false,
            'Visual Arts': false,
            'Extended Essay': false,
            'Theory of Knowledge': false,
            'CAS': false,
        },
    });

    const handleChange = (e) => {
        const { name, type, checked } = e.target;
        if (type === 'checkbox' && formData.program.hasOwnProperty(name)) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                program: { ...prevFormData.program, [name]: checked }
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                subjects: { ...prevFormData.subjects, [name]: type === 'checkbox' ? checked : e.target.value },
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formattedData = {
            student_id: child.id,
            ...formData,
        };

        try {
            await submitDPSubjectSelectionForm(formattedData);
            notifySuccess('Form submitted successfully!');
            setModalVisible(true);
        } catch (error) {
            notifyError('Error submitting form.');
            console.error('Error submitting form:', error);
        }
    };

    const rows = [
        { group: 'STUDIES IN LANGUAGE & LITERATURE', subject: 'ENGLISH A (LANG & LIT)', hl: true, sl: true },
        { group: 'STUDIES IN LANGUAGE & LITERATURE', subject: 'ENGLISH B', hl: true, sl: true },
        { group: 'STUDIES IN LANGUAGE & LITERATURE', subject: 'URDU A (LIT)', hl: true, sl: true },
        { group: 'LANGUAGE ACQUISITION', subject: 'FRENCH AB INITIO', hl: true, sl: true },
        { group: 'LANGUAGE ACQUISITION', subject: 'SPANISH AB INITIO', hl: true, sl: true },
        { group: 'LANGUAGE ACQUISITION', subject: 'ARABIC AB INITIO', hl: true, sl: true },
        { group: 'INDIVIDUALS & SOCIETIES', subject: 'BUSINESS MANAGEMENT', hl: true, sl: true },
        { group: 'INDIVIDUALS & SOCIETIES', subject: 'GLOBAL POLITICS', hl: true, sl: true },
        { group: 'INDIVIDUALS & SOCIETIES', subject: 'ECONOMICS', hl: true, sl: true },
        { group: 'SCIENCES', subject: 'BIOLOGY ', hl: true, sl: true },
        { group: 'SCIENCES', subject: 'CHEMISTRY ', hl: true, sl: true },
        { group: 'SCIENCES', subject: 'PHYSICS ', hl: true, sl: true },
        { group: 'MATHEMATICS', subject: 'MATHEMATICS', hl: true, sl: true },
        { group: 'MATHEMATICS', subject: 'MATHEMATICAL STUDIES', hl: true, sl: true },
        { group: 'THE ARTS', subject: 'VISUAL ARTS', hl: true, sl: true },
    ];

    return (
        <Container sx={{ p: 4, backgroundColor: 'white', borderRadius: '8px', width: '90%', maxWidth: '800px', margin: '100px auto', marginBottom: '20px' }}>
            <Typography variant="h5" gutterBottom>
                DP Subject Selection Form
            </Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6" align="start">Please select program</Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center" spacing={2}>
                        <Grid item xs={4} container justifyContent="center" alignItems="center">
                            <Typography align="start">Diploma</Typography>
                            <Checkbox color="primary" name="diploma" checked={formData.program.diploma} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={4} container justifyContent="center" alignItems="center">
                            <Typography align="center">Course</Typography>
                            <Checkbox color="primary" name="course" checked={formData.program.course} onChange={handleChange} />
                        </Grid>
                        <Grid item xs={4} container justifyContent="center" alignItems="center">
                            <Typography align="center">Retake</Typography>
                            <Checkbox color="primary" name="retake" checked={formData.program.retake} onChange={handleChange} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" align="start">Please select</Typography>
                        <Typography align="start">One subject from each group</Typography>
                        <Typography align="start">At least three subjects at Higher Level (HL)</Typography>
                        <Typography align="start">Three subjects or remaining at Standard Level (SL)</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#d4cfcf' }}>
                                        <TableCell sx={{ fontSize: '1rem' }}>Group</TableCell>
                                        <TableCell>Subject</TableCell>
                                        <TableCell>HL</TableCell>
                                        <TableCell>SL</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.group}</TableCell>
                                            <TableCell>{row.subject}</TableCell>
                                            <TableCell>
                                                {row.hl && <Checkbox color="primary" name={row.subject + " HL"} checked={formData.subjects[row.subject + " HL"]} onChange={handleChange} />}
                                            </TableCell>
                                            <TableCell>
                                                {row.sl && <Checkbox color="primary" name={row.subject + " SL"} checked={formData.subjects[row.subject + " SL"]} onChange={handleChange} />}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12} mb="10px">
                        <Typography variant="h6" align="start" mb="10px">Please Note:</Typography>
                        <Typography align="start">French ab initio, Spanish ab initio, Arabic ab initio, and Mathematical Studies are only offered at SL. All other subjects are available at both SL and HL.</Typography>
                        <Typography align="start">Students interested in Medicine or Natural Sciences Tripos at the University of Cambridge can opt for all 3 sciences. However, they will be required to complete a Non-Regular Diploma request form for approval by IBO.</Typography>
                        <Typography align="start">Offered subject list is reviewed and adjusted on an annual basis.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit">
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
        </Container>
    );
};

export default DPSubject;
